import { render } from "./CompanyHistory.vue?vue&type=template&id=6b892a9d&scoped=true"
const script = {}

import "./CompanyHistory.vue?vue&type=style&index=0&id=6b892a9d&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b892a9d"]])

export default __exports__